import { render, staticRenderFns } from "./Index-Dashboard.vue?vue&type=template&id=a1dbe49c&scoped=true"
import script from "./Index-Dashboard.vue?vue&type=script&lang=js"
export * from "./Index-Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Index-Dashboard.vue?vue&type=style&index=0&id=a1dbe49c&prod&scoped=true&lang=css"
import style1 from "./Index-Dashboard.vue?vue&type=style&index=1&id=a1dbe49c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dbe49c",
  null
  
)

export default component.exports